var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRestaurant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M220.134 0H80C28.9334 0 0 28.9334 0 80V220.001C0 271.066 28.9334 300 80 300H220.134C271.2 300 300 271.066 300 220.001V80C300 28.9334 271.2 0 220.134 0Z",
    fill: "#C4C4C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M152.262 219.665C189.488 219.665 219.665 189.488 219.665 152.262C219.665 115.036 189.488 84.8594 152.262 84.8594C115.036 84.8594 84.8594 115.036 84.8594 152.262C84.8594 189.488 115.036 219.665 152.262 219.665Z",
    fill: "#C4C4C4",
    fillOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M152.264 199.153C178.16 199.153 199.153 178.16 199.153 152.264C199.153 126.368 178.16 105.375 152.264 105.375C126.368 105.375 105.375 126.368 105.375 152.264C105.375 178.16 126.368 199.153 152.264 199.153Z",
    fill: "#C4C4C4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5239 92.5385C93.2967 92.5385 91.5384 94.3554 91.5384 96.524V112.29C91.5384 113.463 90.6006 114.342 89.487 114.342C88.3148 114.342 87.4357 113.404 87.4357 112.29V96.6998C87.4357 94.5312 85.7359 92.5971 83.5673 92.5385C81.2815 92.4799 79.4059 94.2968 79.4059 96.524V112.29C79.4059 113.463 78.4682 114.342 77.3545 114.342C76.1823 114.342 75.3032 113.404 75.3032 112.29V96.6998C75.3032 94.5312 73.6034 92.5971 71.4348 92.5385C69.1489 92.4799 67.2734 94.2968 67.2734 96.524V123.368C67.2734 128.657 69.8363 133.37 73.7722 136.314C77.2959 138.302 77.2959 147.398 77.2959 147.398V206.127C77.2959 209.174 79.7575 211.636 82.8053 211.636H84.1534C87.2012 211.636 89.6628 209.174 89.6628 206.127V147.398C89.6628 147.398 89.6628 138.657 93.1865 136.314C97.1225 133.37 99.6854 128.657 99.6854 123.368V96.524C99.5682 94.3554 97.7512 92.5385 95.5239 92.5385Z",
    fill: "#C4C4C4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M221.774 92.5391C227.049 92.5391 231.328 96.8175 231.328 102.092L231.327 206.186C231.327 209.234 228.865 211.696 225.818 211.696H224.47C221.422 211.696 218.96 209.234 218.96 206.186V155.681C212.37 152.701 208.118 146.127 208.118 138.783V106.254C208.059 98.6932 214.155 92.5391 221.774 92.5391Z",
    fill: "#C4C4C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestaurant);
export default __webpack_public_path__ + "static/media/restaurant.e4169424e2d03bbc40ef33de4e4181e6.svg";
export { ForwardRef as ReactComponent };